import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { msalConfig } from '~/services/auth-service';
import { clearAppPersistence } from '~/shared/utils/persistence';

export default function AuthLogout() {
  const { instance } = useMsal();

  useEffect(() => {
    clearAppPersistence();

    const activeAccount = instance.getActiveAccount();
    const accounts = instance.getAllAccounts();
    const account = activeAccount ?? accounts[0] ?? null;

    if (account) {
      instance.logoutRedirect({
        account,
        postLogoutRedirectUri:
          msalConfig.auth.postLogoutRedirectUri ?? `${window.location.origin}/signin`,
      });
    } else {
      // No account in MSAL cache; just send user back to sign-in (persistence already cleared above).
      window.location.href = '/signin';
    }
  }, [instance]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Logging out...</h2>
      <p>You will be signed out and redirected.</p>
    </div>
  );
}
